/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    platformPackageList: '',
    iosTotalCount: '',
    androidTotalCount: '',
    h5TotalCount: '',
    windowsTotalCount: '', 
    gameRegionList: [], // 地区
    gamePackageList: [], // 包名
    gameStoreList: [], // 发行渠道
    authServerList: '',
    testServerList: ''

};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    GET_GAME_REGION_LIST({state, commit, dispatch, rootState}, args) {

        let package_ajax_game_region_list_url = rootState.$config.api.package_ajax_game_region_list_url;
        rootState.$helper.request.get(package_ajax_game_region_list_url, args)
            .then((res) => {
                commit('_getGameRegionList', res.data.result);
            })
            .catch((res) => {
                dispatch('ERROR_HANDLE', res, {root: true});
            });

    },
    GET_GAME_PACKAGE_LIST({state, commit, dispatch, rootState}, args) {

        let package_ajax_game_package_list_url = rootState.$config.api.package_ajax_game_package_list_url;
        rootState.$helper.request.get(package_ajax_game_package_list_url, args)
            .then((res) => {
                commit('_getGamePackageList', res.data.result);
            })
            .catch((res) => {
                dispatch('ERROR_HANDLE', res, {root: true});
            });

    },

    GET_GAME_STORE_LIST({state, commit, dispatch, rootState}, args) {

        let package_ajax_game_store_list_url = rootState.$config.api.package_ajax_game_store_list_url;
        rootState.$helper.request.get(package_ajax_game_store_list_url, args)
            .then((res) => {
                commit('_getGameStoreList', res.data.result);
            })
            .catch((res) => {
                dispatch('ERROR_HANDLE', res, {root: true});
            });
    },

    GET_PLATFORM_PACKAGE_ALL_LIST({state, commit, dispatch, rootState}, args) {

        console.log('GET_PLATFORM_PACKAGE_ALL_LIST', args);
        let package_games_list_url = rootState.$config.api.package_games_list_url;
        package_games_list_url = package_games_list_url.replace('{game_code}', args.game_code);

        rootState.$helper.request.get(package_games_list_url, args)
            .then((res) => {
                commit('_setPlatformPackageList', res.data);
            })
            .catch((res) => {
                dispatch('ERROR_HANDLE', res, {root: true});
            });

    },
    ADD_PACKAGE({state, commit, dispatch, rootState}, args) {

        let package_add_package_url = rootState.$config.api.package_add_package_url;
        package_add_package_url = package_add_package_url.replace('{game_code}', args.game_code);

        rootState.$helper.request.put(package_add_package_url, args)
            .then((res) => {
                dispatch('GET_PLATFORM_PACKAGE_ALL_LIST', {
                    game_code: args.game_code,
                    platform: args.platform,
                    package_name: args.select_package_value,
                    region_code: args.select_country_value
                });
                dispatch('GET_GAME_PACKAGE_LIST', {
                    game_code: args.game_code,
                    platform: args.platform
                });

                if (typeof args.callback === 'function') {
                    args.callback();
                }
            })
            .catch((res) => {
                args.errCallback();
                dispatch('ERROR_HANDLE', res, {root: true});
            });

    },
    EDIT_PACKAGE({state, commit, dispatch, rootState}, args) {

        let package_edit_del_package_url = rootState.$config.api.package_edit_del_package_url;
        package_edit_del_package_url = package_edit_del_package_url.replace('{game_code}', args.game_code);
        package_edit_del_package_url = package_edit_del_package_url.replace('{package_id}', args.package_region_id);

        rootState.$helper.request.put(package_edit_del_package_url, args)
            .then((res) => {
                dispatch('GET_PLATFORM_PACKAGE_ALL_LIST', {
                    game_code: args.game_code,
                    platform: args.platform,
                    package_name: args.select_package_value,
                    region_code: args.select_country_value
                });
                dispatch('GET_GAME_PACKAGE_LIST', {
                    game_code: args.game_code,
                    platform: args.platform
                });

                if (typeof args.callback === 'function') {
                    args.callback();
                }

            })
            .catch((res) => {
                args.errCallback();
                dispatch('ERROR_HANDLE', res, {root: true});
            });

    },
    DELETE_PACKAGE_BY_ID({state, commit, dispatch, rootState}, args) {

        let package_edit_del_package_url = rootState.$config.api.package_edit_del_package_url;
        package_edit_del_package_url = package_edit_del_package_url.replace('{game_code}', args.game_code);
        package_edit_del_package_url = package_edit_del_package_url.replace('{package_id}', args.package_id);

        rootState.$helper.request.delete(package_edit_del_package_url)
            .then((res) => {
                dispatch('GET_PLATFORM_PACKAGE_ALL_LIST', {game_code: args.game_code, platform: args.platform});
            })
            .catch((res) => {
                dispatch('ERROR_HANDLE', res, {root: true});
            });
    },
    GET_SERVER_LIST_BY_REGION({state, commit, dispatch, rootState}, args) {

        let package_server_list_region_url = rootState.$config.api.package_server_list_region_url;

        rootState.$helper.request.get(package_server_list_region_url, args)
            .then((res) => {
                commit('_getServerList', res.data.result);
            })
            .catch((res) => {
                dispatch('ERROR_HANDLE', res, {root: true});
            });

    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 *
 */
const getters = {
    GET_DEMO_GETTER(state, getters) {
        let data = getters.getDemoGetterOthr;
        state.demoList = state.demoList.concat(data);
        return state.demoList;

    },

    getDemoGetterOthr(state, getters) {
        return [{id: 4, data: 'aata4'}];
    }

};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {

    _getGameRegionList(state, args) {
        state.gameRegionList = args;
    },
    _getGamePackageList(state, args) {
        state.gamePackageList = args;
    },
    _getGameStoreList(state, args) {
        state.gameStoreList = args;
    },
    _addPackageList(state, args) {
        state.packageList.push(args);
    },
    _setPlatformPackageList(state, args) {
        state.platformPackageList = args.packages;
        state.iosTotalCount = args.ios_count;
        state.androidTotalCount = args.android_count;
        state.h5TotalCount = args.h5_count;
        state.windowsTotalCount = args.windows_count;
    },

    _getServerList(state, args) {

        state.authServerList = args.auth_serverlist;
        state.testServerList = args.test_serverlist;
    },
    /**
     * 对外的方法
     * @param state
     * @param args
     * @constructor
     */
    DEMO_MUTATIONS(state, args) {
        state.demoStatus = args;
        console.log(state.demoStatus);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./website/store/modules/gameConfig/PackagePlanManager.js